import React, { Component } from 'react';
import Parse from 'parse';
import {GetUrlVariable} from './../../utils/functions';
import ReportSectionEditableImage from './../reportSectionEditableImage';
export default class BlogSection extends Component {
  constructor(props) {
      super(props);
      this.state = {};
  }

  deleteSection = async() => {
    var posts = Parse.Object.extend("YipitReportSections");
    var query = new Parse.Query(posts);
    let post = await query.get(this.state.id)
    post.set("deleted",true);
    let blogPost = await post.save();
    this.setState({
      item:blogPost
    })
  }

  componentDidMount = () =>{
    this.initScreen();
  }
  initScreen = () =>{
    let item = this.props.item;
    this.setState({
      id:item.id,
      item:item
    })
  }
  render() {
    let item = this.state.item;
    if(!item) return null;
    return (
      <div className="section-wrapper white-background report-image-section">
         <div className="tiny-padding">
          <ReportSectionEditableImage
            item={item}
            parseclass="YipitReportSections"
            ratio="rectangle"
            parseobjectid={item.id}
            parsekey="image"
             />
         </div>
      </div>
    );
  }
}
